import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import { useGetTeamFacebookIntegrations } from '../../services/meta.service';
import { useIntegrationsStore } from '../../store';

export const useGetFacebookIntegrations = () => {
  const { getTeamFacebookIntegrations } = useGetTeamFacebookIntegrations();
  const { setTeamFacebookIntegrations } = useIntegrationsStore();

  const handleFetchFacebookIntegrations = (
    teamId: string,
    forceRefresh = false,
  ) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.MESSENGER,
      scope: teamId,
      forceRefresh,
      fetch: () => getTeamFacebookIntegrations(teamId),
      write: setTeamFacebookIntegrations,
    });

  return { handleFetchFacebookIntegrations };
};
